<script>
const allowed = {
  letters: 'abcdefghijklmnopqrstuvwxyz',
  numbers: '1234567890',
  symbols: '!@#$%^&*',
};

const getRandomCharFromString = (str) => str.charAt(Math.floor(Math.random() * str.length));

const generatePassword = (length = 8) => {
  let pwd = '';
  pwd += getRandomCharFromString(allowed.letters.toUpperCase()); // pwd will have at least one upper
  pwd += getRandomCharFromString(allowed.letters); // pwd will have at least one lower
  pwd += getRandomCharFromString(allowed.numbers); // pwd will have at least one number
  pwd += getRandomCharFromString(allowed.symbols); // pwd will have at least one symbol
  for (let i = pwd.length; i < length; i++)
    pwd += getRandomCharFromString(Object.values(allowed).join('')); // fill the rest of the pwd with random characters
  return pwd;
};

export default {
  methods: {
    generate() {
      const password = generatePassword(12);
      this.$emit('password-generated', password);
    },
  },
};
</script>

<template>
  <div>
    <BaseButton primary outline type="button" @click="generate()">Προτεινε μου κωδικο</BaseButton>
  </div>
</template>
